import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../slices";

interface AuthProtectedProps {
  children: ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
  // Check both Redux state and localStorage for authentication
  const { isAuthenticated } = useSelector((state: RootState) => state.Login);
  const hasToken = localStorage.getItem("accessToken");
  
  console.log('AuthProtected check:', { isAuthenticated, hasToken });
  
  if (!isAuthenticated && !hasToken) {
    console.log('Redirecting to login - not authenticated');
    return <Navigate to={{ pathname: "/login" }} />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthProtected;
